import React from 'react'
import { Form, ModalBody, Button, Col, FormGroup, Row, ListGroup, ListGroupItem } from 'reactstrap';
import Select from 'react-select';


export const FormIndicationExam = (props) => {

    const {
        // ? INDICATIONS PATIENT
        loading, listIndication, CreateOrUpdateExamIndications, handleSelectValuesIndication, dataIndication,
        // ? INDICATIONs LABORATORY
        dataIndicationLab, listIndicationLab, handleSelectValuesIndication2

    } = props;

    return (
        <Form className="theme-form" role="form" onSubmit={CreateOrUpdateExamIndications}>
            <Col className='mt-2'>
            </Col>
            <Col sm="12">
                <Row>
                    <Col sm="12">
                        <h6 className='txt-danger f-w-500'>Agregar las indicaciones en sus respectivas listas</h6>
                    </Col>
                    <Col sm="6">
                        <Col sm="12" className='mb-2 p-l-0'>
                            <FormGroup>
                                <Select
                                    isMulti
                                    isClearable={false}
                                    name="listIndication"
                                    value={listIndication}
                                    onChange={(e) => handleSelectValuesIndication(e, "listIndication")}
                                    options={dataIndication}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Selecciona una o varias opciones"
                                    noOptionsMessage={() => "Sin opciones"}
                                    isSearchable={true}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                            minHeight: '38px'
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            padding: '2px 8px',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: "#b6bdc4",
                                            fontSize: '11px',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),


                                        menuPortal: base => ({ ...base, zIndex: 999999 })
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="12" className='mt-2 p-l-0'>
                            <b className='txt-warning'>Indicaciones para pacientes</b>
                            <ListGroup className='mt-2'>
                                {
                                    listIndication.length > 0 ? (
                                        listIndication.map((_find, _key) => (
                                            <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                                <label className='f-w-600 mb-0' style={{ fontSize: "10px" }}>{_find?.label ?? "----"}</label>
                                                <i className="fa fa-check text-success"></i>
                                            </ListGroupItem>
                                        ))
                                    ) : (
                                        <ListGroupItem className="d-flex justify-content-center align-items-center">
                                            <i className='fa fa-warning text-danger' ></i>
                                            <label className='f-w-600 txt-danger  mb-0 ml-2' style={{ fontSize: "11px" }}>No se a asigando indicaciones en esta prueba</label>
                                        </ListGroupItem>
                                    )
                                }
                            </ListGroup>
                        </Col>
                    </Col>
                    <Col sm="6">
                        <Col sm="12" className='mb-2 p-l-0'>
                            <FormGroup>
                                <Select
                                    isMulti
                                    isClearable={false}
                                    name="listIndicationLab"
                                    value={listIndicationLab}
                                    onChange={(e) => handleSelectValuesIndication2(e, "listIndicationLab")}
                                    options={dataIndicationLab}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Selecciona una o varias opciones"
                                    noOptionsMessage={() => "Sin opciones"}
                                    isSearchable={true}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                            minHeight: '38px'
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            padding: '2px 8px',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: "#b6bdc4",
                                            fontSize: '11px',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            fontSize: '11px',
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 999999 })
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="12" className='mt-2 p-l-0'>
                            <b className='txt-success'>Indicaciones para laboratorio</b>
                            <ListGroup className='mt-2'>
                                {
                                    listIndicationLab.length > 0 ? (
                                        listIndicationLab.map((_find, _key) => (
                                            <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                                <label className='f-w-600 mb-0' style={{ fontSize: "10px" }}>{_find?.label ?? "----"}</label>
                                                <i className="fa fa-check text-success"></i>
                                            </ListGroupItem>
                                        ))
                                    ) : (
                                        <ListGroupItem className="d-flex justify-content-center align-items-center">
                                            <i className='fa fa-warning text-danger' ></i>
                                            <label className='f-w-600 txt-danger mb-0 ml-0' style={{ fontSize: "11px" }}>No se a asigando indicaciones en esta prueba</label>
                                        </ListGroupItem>
                                    )
                                }
                            </ListGroup>
                        </Col>
                    </Col>
                </Row>
            </Col>

            <div className='mt-4' style={{ "text-align": "-webkit-right" }}>
                <Button outline color="primary" type="submit" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {"Guardar"}
                </Button>
            </div>
        </Form>
    )
}
